import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	padding: 20px 0;
	gap: 15px;

	@media (min-width: 600px) {
		width: 80vw;
		max-width: 800px;
	}
`;

export const Title = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 20px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 28px */
`;

export const HorizontalList = styled.div`
	display: flex;
	flex-direction: row;
	width: 90vw;
	overflow-x: scroll;
	scrollbar-width: none;
	gap: 30px;
	max-width: 340px;
	scroll-snap-type: x mandatory;
`;

export const Stage = styled.div`
	scroll-snap-align: start;
	scroll-snap-stop: always;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 10px;
`;

export const StageImage = styled.img`
	width: 90vw;
	max-width: 340px;
`;

export const StageItems = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	justify-content: center;
	box-sizing: border-box;
	padding: 0 50px;
`;

export const StageItem = styled.div`
	display: grid;
	grid-template-columns: 40px 1fr;
`;

export const StageItemIcon = styled.img`
	align-self: center;
	justify-self: center;
`;

export const StageItemText = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 100%; /* 12px */

	align-self: center;
`;

export const SkipButton = styled.div`
	color: var(--Text-color, #29185e);
	text-align: center;
	font-family: 'Work Sans';
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: 140%; /* 22.4px */
	text-decoration-line: underline;
	text-decoration-style: solid;
	text-decoration-skip-ink: none;
	text-decoration-thickness: auto;
	text-underline-offset: auto;
	text-underline-position: from-font;
`;

export const ProgressIndicatorList = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap: 8px;
`;

export const ProgressIndicator = styled.div<{ isActive: boolean }>`
	width: ${({ isActive }) => (isActive ? '7px' : '6px')};
	height: ${({ isActive }) => (isActive ? '7px' : '6px')};
	border-radius: 50%;
	background-color: ${({ isActive }) => (isActive ? '#29185E' : '#D9D9D9')};
	transition: background-color 0.3s ease;
`;
